import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { EditWorkspaceCallable } from "@/action-dialog/callables";
import type {
  UpdateWorkspaceRequest,
  Workspace,
  WorkspaceMetadata,
} from "@cohesive/api-client";
import toast from "react-hot-toast";

export interface EditWorkspaceParams {
  workspace: Workspace;
  updateWorkspace: {
    mutateAsync: (args: {
      id: string;
      data: UpdateWorkspaceRequest;
    }) => Promise<unknown>;
  };
  onSuccess?: (workspace: Workspace) => void | Promise<void>;
}

export function runEditWorkspaceWorkflow(
  params: EditWorkspaceParams,
): Promise<boolean> {
  const { workspace, updateWorkspace, onSuccess } = params;

  return withActionDialogLock(() =>
    EditWorkspaceCallable.call({
      workspace,
      mutationFn: async (call, values) => {
        // Description travels top-level; metadata carries only display extras (icon).
        const nextMetadata: WorkspaceMetadata = {
          icon: values.icon ?? null,
        };
        await updateWorkspace.mutateAsync({
          id: workspace.id,
          data: {
            name: values.name,
            description: values.description,
            metadata: nextMetadata,
          },
        });
        toast.success("Workspace updated");
        await onSuccess?.(workspace);
        call.end(true);
      },
    }),
  );
}
